export default "__VITE_ASSET__BYCBSA2s__"